import { Effect, all, call, cancel, cancelled, fork, put, take, takeEvery } from "redux-saga/effects";
import { Action } from "redux";
import { EventChannel, Task } from "redux-saga";
import { SharedCallsData } from "@sms/shared/calls/calls.interface";

import { connectSocketCalls, createSocketEventsCallsChannel, socketCalls } from "./calls.socket";
import { handleConnectSocketCalls, initCallsList } from "./calls.actions";

function fetchCallListData(): Promise<SharedCallsData[]> {
  return new Promise((resolve, reject) => {
    socketCalls.emit("fetchList", (data: SharedCallsData[]) => {
      if (data) {
        resolve(data);
      } else {
        reject(new Error("Failed to fetch call list."));
      }
    });
  });
}

function* fetchCallListSaga(): Generator<Effect, void, SharedCallsData[]> {
  try {
    const calls: SharedCallsData[] = yield call(fetchCallListData);

    yield put(initCallsList(calls));
  } catch (error) {
    // Handle error or dispatch an error action
    // For example: yield put({ type: 'FETCH_CALL_LIST_ERROR', error });
  }
}

function* connectSocketCallsSaga(): Generator<Effect, void, Task> {
  let task: Task | null = null;

  try {
    yield call(connectSocketCalls);

    task = yield fork(socketCallsWatchers);
  } finally {
    if (yield cancelled()) {
      socketCalls.close();
      if (task !== null) {
        yield cancel(task);
      }
    }
  }
}

function* socketCallsWatchers(): Generator<Effect | Generator, void, EventChannel<any> | Action<any>> {
  const socketEventsCallsChannel: EventChannel<any> = (yield call(createSocketEventsCallsChannel)) as EventChannel<any>;

  try {
    while (true) {
      const action: Action<any> = (yield take(socketEventsCallsChannel)) as Action<any>;

      yield put(action);
    }
  } finally {
    if (yield cancelled()) {
      socketEventsCallsChannel.close();
    }
  }
}

export function* CallsWatchers(): Generator<Effect | Generator, void> {
  yield all([takeEvery(handleConnectSocketCalls, () => fetchCallListSaga())]);
}

export function* callsServices(): Generator<Effect | Generator, void, void> {
  yield all([fork(CallsWatchers), fork(connectSocketCallsSaga)]);
}
